import React, {useState, useContext} from "react";
import Box from "@mui/material/Box";
import {get} from '@api/barcodes';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {DataGrid} from '@mui/x-data-grid';
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {Filter} from './Filter';
import { renderCellExpand } from "@components/renderCellExpand";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    button: {
        width: '100%',
        margin: '10px',
    },
    filters: {
        width: '100%',
        margin: '10px',
    }
});

const columns = [
    {field: 'benefitId', headerName: 'benefitId', renderCell: renderCellExpand},
    {field: 'code', headerName: 'code', renderCell: renderCellExpand},
    {field: 'id', headerName: 'id', renderCell: renderCellExpand},
    {field: 'preAssignExpirationOn', headerName: 'preAssignExpirationOn', renderCell: renderCellExpand},
    {field: 'status', headerName: 'status', renderCell: renderCellExpand},
    {field: 'used', headerName: 'used', renderCell: renderCellExpand},
    {field: 'availableFrom', headerName: 'availableFrom', renderCell: renderCellExpand},
];

export const Barcodes = () => {
        const classes = useStyles();
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage} = useContext(MessageContext);
        const [rows, setRows] = useState([]);

        const onSubmit = async (data) => {
            try {
                setLoading(true);
                setErrorMessage(null);
                const barcodes = await get(data);
                setRows(barcodes)
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        return (
            <Box
                className={classes.root}
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={'column'}
                alignItems={"center"}
            >
                <Box className={classes.filters}><Filter onSubmit={onSubmit}/></Box>
                <Box style={{minHeight: 400, width: '100%'}}>
                    <DataGrid
                        autoHeight={true}
                        rows={rows}
                        columns={columns}
                    />
                </Box>
            </Box>
        );
    }
;